import instagram from '../assets/svg/instagram.svg';
import linkedin from '../assets/svg/linkedin.svg';
import mintBg from '../assets/svg/logo-background.jpg';
import logo from '../assets/svg/logo-big.svg';
import mint from '../assets/svg/logo-small.svg';
import twitter from '../assets/svg/twitter.svg';

const networks = {
  linkedin: {
    href: 'https://www.linkedin.com/company/mintspa/',
    icon: linkedin,
  },
  instagram: {
    href: 'https://www.instagram.com/mint.ai_official/',
    icon: instagram,
  },
  twitter: {
    href: 'https://twitter.com/mint_ai_/',
    icon: twitter,
  },
} as const;

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-between bg-greyscale-white">
      <header className="relative top-0 w-full bg-contain bg-no-repeat pt-[10.6%]">
        <img
          src={mintBg}
          alt="Mint background"
          className="absolute top-0 left-0 h-full w-full object-cover"
        />
        <img
          className="absolute top-1/2 left-1/2 w-[23%] -translate-x-1/2 -translate-y-1/2 transform"
          src={logo}
          alt="Mint logo"
        />
      </header>
      <div className="my-10 flex items-center justify-center">{children}</div>
      <footer className="bottom-0 left-0 flex h-22 w-full flex-col items-center justify-between border-t border-solid border-border-primary py-4">
        <div className="flex w-22 justify-between">
          {Object.keys(networks).map((key) => {
            const network = networks[key as keyof typeof networks];
            return (
              <a
                key={key}
                href={network.href}
                className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-[50%] bg-greyscale-black/6 fill-icon-primary transition-opacity hover:opacity-[0.65]"
              >
                <img className="transform" src={network.icon} alt={key} />
              </a>
            );
          })}
        </div>

        <a href="https://mint.ai" className="cursor-pointer">
          <img
            src={mint}
            alt="Mint small logo"
            className="fill-secondary-main"
          />
        </a>
      </footer>
    </div>
  );
}

export default Layout;
